import React, { Component } from "react";
import "./ArchivedListView.scss";
import EmptyStates from "../EmptyStates/EmptyStates";
import { apolloClient } from "../../index";
import { gql } from "@apollo/client";
import ListViewHeader from "../ListView/ListViewHeader/ListViewHeader";
import DynamicListViewRows from "../ListView/ListViewRows/DynamicListViewRows";
import FolderRoute from "../SubHeader/SubHeader";
import emptyArchiveImage from "../../assets/EmptyStates/empty_archive.svg";
import { notify } from "../Notify/Notify";
import ArchiveBreadcrumbs from "./ArchiveBreadcrumbs/ArchiveBreadcrumbs";
import dateFormat from "dateformat";
import { getCapitals, getIntials, getParsedDate } from "../../helper";
import Spinner from "react-bootstrap/Spinner";
import ColumnsIcon from "../../assets/icons/layout-columns.svg";
import CustomizeColumnModal from "../DocumentExplorer/DocumentListView/CustomizeColumnModal/CustomizeColumnModal";
import DocumentView from "../DocumentView/DocumentView";
import { ColumnSortingState } from "../FolderExplorer/FolderListView/FolderListView";

//Restore folders and documents
const RESTORE_FOLDER = `mutation RestoreFolders($folders: [UUID]) {
  restoreFolders(folders: $folders) {
    success
  }
}`;

const RESTORE_DOCUMENT = `
mutation RestoreDocument($documents: [UUID]){
  restoreDocument(documents: $documents){
    success
  }
}`;

// Delete folders and documents
const DELETE_FOLDER = ` mutation DeleteFolders($folders: [UUID]) {
  deleteFolders(folders: $folders) {
    success
  }
}`;

const DELETE_DOCUMENT = `mutation DeleteDocument($documents: [UUID]){
  deleteDocument(documents: $documents){
    success
  }
}`;

class ArchivedListView extends Component {
  state = {
    availableColumns: [
      "location",
      "archivedBy",
      "archivedOn",
      "archivedTill",
      "fileSize",
      "createdOn",
      "addedBy",
      "modifiedOn",
      "modifiedBy",
    ],
    heading: ["files", "location", "archivedBy", "archivedOn", "archivedTill"],
    documentItems: this.props.archivedItems,
    totalDocuments: this.props.archivedItems.length,
    subFolderItems: [],
    docItems: [],
    checked: {},
    selectAll: false,
    displayListView: true,
    isColumns: {
      isCheckbox: true,
      isTitle: true,
      isLocation: true,
      isArchivedBy: true,
      isArchivedOn: true,
      isDropDown: true,
      isPopover: true,
      isArchivedDropdown: true,
    },
    isArchivedView: true,
    tableSizeLarge: true,
    restore: [],
    delete: [],
    selectedColumn: "A-Z",
    isLoading: false,
    filterLength: false,
    showCustomizeColumnModal: false,
    columns: [],
    reloadColumns: true,
    showDocumentDetailModal: false,
    shouldShowDocumentModal: this.props.match.params.docId ? true : false,
    documentDetailModalInfo: {},
    sortingValue: {column: "Files", status: ColumnSortingState.ASC},
    filterData: {},
    startDate: null,
    endDate: null,
  };

  columnsDisplayMapping = {
    files: "Files",
    location: "Location",
    archivedBy: "Archived By",
    archivedOn: "Archived On",
    archivedTill: "Archived Till",
    fileSize: "File Size",
    createdOn: "Created On",
    addedBy: "Created By",
    modifiedOn: "Modified On",
    modifiedBy: "Modified By",
  };

  sortableColumns = ["Files", "Archived On", "Archived Till"]

  componentDidMount() {
    if (this.props.isSubFolderArchive && this.props.isSubArchive) {
      this.setState({
        documentItems: [],
        totalDocuments: 0,
        isLoading: true,
      });
      this.fetchArchiveSubFolders();
    }

    if (this.props.isDocumentArchive) {
      this.setState({ documentItems: [], totalDocuments: 0, isLoading: true });
      this.fetchArchiveDocuments();
    }
    let checkedDocument = {};
    this.state.documentItems.map(
      (rpKey) => (checkedDocument[rpKey.id] = false)
    );
    this.setState({ checked: checkedDocument });
  }

  fetchArchiveSubFolders = () => {
    const variables = {
      parentFolderId: this.props.match.params.folderId,
    };
    apolloClient
      .query({
        query: gql`
          query archiveSubFolders($parentFolderId: UUID!) {
            archiveSubFolders(parentFolderId: $parentFolderId) {
              id
              title
              color {
                id
                name
              }
              parentFolder {
                id
                title
                color {
                  id
                }
              }
              createdBy {
                username
                firstName
                lastName
                profile {
                  id
                  image
                  role {
                    id
                    name
                  }
                }
              }
              createdTs
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.archiveSubFolders.length === 0) {
          const archiveSubFolders = result.data.archiveSubFolders;
          const archiveSubFolderIds = archiveSubFolders.map(
            (archiveSubFolder) => archiveSubFolder.id
          );
          const newArchivedItems = [...this.props.archivedItems];
          const upadtedArchivedItems = [];
          const newSubfolders = [];
          newArchivedItems.map((documentItem) => {
            if (documentItem.folder) {
              if (
                archiveSubFolderIds.includes(documentItem.folder.id) &&
                this.props.match.params.folderId ===
                  documentItem.folder.parentFolder.id
              ) {
                upadtedArchivedItems.push(documentItem);
              }
            } else {
              if (
                !newSubfolders.includes(documentItem.document.folder.id) &&
                this.props.match.params.folderId ===
                  documentItem.document.folder.parentFolder.id
              ) {
                const newItem = { ...documentItem };
                const newItem2 = newItem.document.folder;
                newItem.folder = newItem2;
                newItem.document = null;
                newItem.isFolder = true;
                newSubfolders.push(documentItem.document.folder.id);
                upadtedArchivedItems.push(newItem);
              }
            }
            return true;
          });
          let checkedDocument = {};
          upadtedArchivedItems.map(
            (rpKey) => (checkedDocument[rpKey.id] = false)
          );
          this.setState({
            documentItems: upadtedArchivedItems,
            subFolderItems: upadtedArchivedItems,
            totalDocuments: upadtedArchivedItems.length,
            isLoading: false,
            checked: checkedDocument,
          });
        } else {
          let upadtedArchivedItems = [];
          let newSubfolders = [];
          const newArchivedItems = [...this.props.archivedItems];
          const findRootFolder = this.props.archivedItems.find((doc) =>
            doc.rootId !== null
              ? doc.rootId === this.props.match.params.folderId
              : doc.parentId === this.props.match.params.folderId
          );
          result.data.archiveSubFolders.map((archiveSub) => {
            const newObj = Object.assign({}, archiveSub, {
              id: archiveSub.id,
              color: archiveSub.color,
              rootId: archiveSub.parentFolder.id,
              rootTitle: archiveSub.parentFolder.title,
              parentId: archiveSub.id,
              parentTitle: archiveSub.title,
              archivedBy: findRootFolder.createdBy,
              role: archiveSub.createdBy.profile.role.name,
              archivedOn: dateFormat(archiveSub.createdTs, "dd mmm, yyyy"),
              archivedTill: findRootFolder.archivedTill,
              folder: {
                color: archiveSub.color,
                id: archiveSub.id,
                parentFolder: archiveSub.parentFolder,
                title: archiveSub.title,
              },
              isFolder: true,
              document: null,
            });
            return upadtedArchivedItems.push({ ...newObj });
          });

          newArchivedItems.map((documentItem) => {
            if (
              documentItem.document &&
              this.props.match.params.folderId ===
                documentItem.document.folder.parentFolder.id &&
              !newSubfolders.includes(documentItem.document.folder.id)
            ) {
              const newItem = { ...documentItem };
              const newItem2 = newItem.document.folder;
              newItem.folder = newItem2;
              newItem.document = null;
              newItem.isFolder = true;
              newSubfolders.push(documentItem.document.folder.id);
              upadtedArchivedItems.push(newItem);
            }
            return true;
          });
          let checkedDocument = {};
          upadtedArchivedItems.map(
            (rpKey) => (checkedDocument[rpKey.id] = false)
          );
          this.setState({
            documentItems: upadtedArchivedItems,
            subFolderItems: upadtedArchivedItems,
            totalDocuments: upadtedArchivedItems.length,
            isLoading: false,
            checked: checkedDocument,
          });
        }
      })
      .catch((e) => {});
  };

  fetchArchiveDocuments = () => {
    const variables = {
      folderId: this.props.match.params.subId,
    };
    apolloClient
      .query({
        query: gql`
          query ArchiveDocumentsOfFolder($folderId: UUID!) {
            archiveDocumentsOfFolder(folderId: $folderId) {
              id
              file
              title
              fileUrl
              status {
                id
                name
              }
              tag{
                id
                name
              }
              abstractJson
              folder {
                id
                title
                color {
                  id
                  name
                }
                parentFolder {
                  id
                  title
                  color {
                    id
                  }
                }
              }
              sharedDocument {
                id
                user {
                  id
                  email
                  username
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                userRole {
                  id
                  name
                }
              }
              createdBy {
                id
                email
                username
                firstName
                lastName
                profile {
                  id
                  image
                  role {
                    id
                    name
                  }
                }
              }
              modifiedBy {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              createdTs
              modifiedTs
              documentType {
                title
                id
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let updatedDocumentItems = [];
        const findRootFolder = this.props.archivedItems.find((doc) =>
          doc.rootId !== null
            ? doc.parentId === this.props.match.params.subId
            : doc.parentId === this.props.match.params.folderId
        );
        result.data.archiveDocumentsOfFolder.map((archiveDoc) => {
          const fieldObj = {};
          const parsedAbstractJson = JSON.parse(archiveDoc.abstractJson);
          parsedAbstractJson.map((parsedJson) => {
            parsedJson.tabSections.map((tab) => {
              tab.sectionFields.map((sectionField) => {
                sectionField.inputType === "Date"
                  ? (fieldObj[sectionField.fieldLabel] = dateFormat(
                      sectionField.fieldValue,
                      "mmm dd, yyyy"
                    ))
                  : sectionField.fieldLabel === "Document type" ||
                    sectionField.fieldLabel === "Document Type"
                  ? (fieldObj[getCapitals(sectionField.fieldLabel)] =
                      archiveDoc.documentType.title)
                  : (fieldObj[sectionField.fieldLabel] =
                      sectionField.fieldValue);
                return true;
              });
              return true;
            });
            return true;
          });

          const newObj = Object.assign({}, archiveDoc, {
            id: archiveDoc.id,
            color: archiveDoc.folder.color,
            rootId: archiveDoc.folder.parentFolder.id,
            rootTitle: archiveDoc.folder.parentFolder.title,
            parentId: archiveDoc.folder.id,
            parentTitle: archiveDoc.folder.title,
            archivedBy: findRootFolder.createdBy,
            modifiedBy: archiveDoc.modifiedBy,
            role: archiveDoc.createdBy.profile.role.name,
            archivedOn: dateFormat(archiveDoc.createdTs, "dd mmm, yyyy"),
            archivedTill: findRootFolder.archivedTill,
            document: {
              id: archiveDoc.id,
              title: archiveDoc.title,
              folder: {
                ...archiveDoc.folder,
              },
            },
            folder: null,
            isFolder: false,
            abstractJson: JSON.parse(archiveDoc.abstractJson),
            modifiedOn: getParsedDate(archiveDoc.modifiedTs),
            createdOn: getParsedDate(archiveDoc.createdTs),
            ...fieldObj,
          });
          updatedDocumentItems.push({ ...newObj });
          return true;
        });
        let checkedDocument = {};
        updatedDocumentItems.map(
          (rpKey) => (checkedDocument[rpKey.id] = false)
        );
        this.setState({
          documentItems: updatedDocumentItems,
          docItems: updatedDocumentItems,
          totalDocuments: updatedDocumentItems.length,
          isLoading: false,
          checked: checkedDocument,
        }, () => {
          if (this.state.shouldShowDocumentModal) {
            this.documentOnClickHandler(this.props.match.params.docId, true);
          }
        });
      })
      .catch((e) => {});
  };

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.docId !== this.props.match.params.docId) {
      this.documentOnClickHandler(this.props.match.params.docId, true);
    }
    if (this.props.archivedItems !== prevProps.archivedItems) {
      let checkedDocument = {};
      let checkedItems = { ...this.state.checked };
      this.props.archivedItems.map(
        (rpKey) =>
          (checkedDocument[rpKey.id] = checkedItems[rpKey.id] ? true : false)
      );
      this.setState({
        documentItems: this.props.archivedItems,
        totalDocuments: this.props.archivedItems.length,
        checked: checkedDocument,
      });
    }
  }

  checkHandler = (id) => {
    let checkedItem = this.state.checked;
    checkedItem[id] = !this.state.checked[id];
    let count = 0;
    for (let value of Object.values(checkedItem)) {
      !value && count++;
    }
    this.setState({ checked: checkedItem, selectAll: count === 0 });
  };

  selectAllHandler = () => {
    let checkedDocuments = this.state.checked;

    Object.keys(checkedDocuments).map(
      (sKey) => (checkedDocuments[sKey] = this.state.selectAll ? false : true)
    );

    this.setState({ checked: checkedDocuments });
    this.setState({ selectAll: !this.state.selectAll });
  };

  totalChecked = () => {
    let selectedFolder = 0;
    Object.keys(this.state.checked).map((cKey) =>
      this.state.checked[cKey] ? (selectedFolder += 1) : null
    );
    return selectedFolder;
  };

  restoreAllHandler = () => {
    let selectedId = [];
    Object.keys(this.state.checked).map((cKey) =>
      this.state.checked[cKey] ? selectedId.push(cKey) : null
    );
    const selectedItems = this.state.documentItems.filter((item) =>
      selectedId.includes(item.id)
    );
    let restoreFolders = [];
    let restoreDocuments = [];
    selectedItems.map((selectedItem) => {
      selectedItem.folder
        ? restoreFolders.push(selectedItem.folder.id)
        : restoreDocuments.push(selectedItem.document.id);
      return true;
    });

    const MUTATION =
      restoreDocuments.length > 0 && restoreFolders.length > 0
        ? ` mutation($documents: [UUID], $folders: [UUID]) {
          restoreDocument(documents: $documents) {
            success
          }
          restoreFolders(folders: $folders) {
            success
          }
        }`
        : restoreDocuments.length > 0
        ? `mutation($documents: [UUID]) {
          restoreDocument(documents: $documents) {
            success
          }
        }`
        : restoreFolders.length > 0
        ? `mutation($folders: [UUID]) {
          restoreFolders(folders: $folders) {
            success
          }
        }`
        : ``;
    const variables =
      restoreDocuments.length > 0 && restoreFolders.length > 0
        ? {
            documents: restoreDocuments,
            folders: restoreFolders,
          }
        : restoreDocuments.length > 0
        ? {
            documents: restoreDocuments,
          }
        : restoreFolders.length > 0
        ? {
            folders: restoreFolders,
          }
        : {};

    apolloClient
      .mutate({
        mutation: gql`
          ${MUTATION}
        `,
        variables: variables,
      })
      .then((result) => {
        const updatedRestoreList = [...this.state.restore, ...selectedItems];
        const updateDocumentItems = this.state.documentItems.filter(
          (document) =>
            !updatedRestoreList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        const folderLists = this.props.archivedItems.filter(
          (document) =>
            !updatedRestoreList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        this.props.setFolderList(folderLists, updatedRestoreList);
        this.setState({
          restore: updatedRestoreList,
          documentItems: updateDocumentItems,
          totalDocuments: updateDocumentItems.length,
          selectAll: false,
        });
        const detail = "Success";
        const title = "All items have been successfully restored";
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  restoreHandler = (archiveId, id, itemTitle, isFolder, item) => {
    const MUTATION = isFolder ? RESTORE_FOLDER : RESTORE_DOCUMENT;
    const variables = isFolder
      ? {
          folders: [archiveId],
        }
      : {
          documents: [archiveId],
        };
    apolloClient
      .mutate({
        mutation: gql`
          ${MUTATION}
        `,
        variables: variables,
      })
      .then((result) => {
        const restoreItems = this.state.documentItems.filter(
          (key) => key.id === archiveId
        );
        const updatedRestoreList = [...this.state.restore, ...restoreItems];
        const updateDocumentItems = this.state.documentItems.filter(
          (document) =>
            !updatedRestoreList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        const folderLists = this.props.archivedItems.filter(
          (document) =>
            !updatedRestoreList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        this.props.setFolderList(folderLists, restoreItems);

        this.setState({
          restore: updatedRestoreList,
          documentItems: updateDocumentItems,
          totalDocuments: updateDocumentItems.length,
        });

        const detail = "Success";
        const title = `${itemTitle} restored successfully!`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  deleteAllHandler = () => {
    let selectedId = [];
    Object.keys(this.state.checked).map((cKey) =>
      this.state.checked[cKey] ? selectedId.push(cKey) : null
    );
    const selectedItems = this.state.documentItems.filter((item) =>
      selectedId.includes(item.id)
    );

    let deleteFolders = [];
    let deleteDocuments = [];
    selectedItems.map((selectedItem) => {
      selectedItem.folder
        ? deleteFolders.push(selectedItem.folder.id)
        : deleteDocuments.push(selectedItem.document.id);
      return true;
    });

    const MUTATION =
      deleteDocuments.length > 0 && deleteFolders.length > 0
        ? `mutation($documents: [UUID], $folders: [UUID]) {
          deleteDocument(documents: $documents) {
            success
          }
          deleteFolders(folders: $folders) {
            success
          }
        }`
        : deleteDocuments.length > 0
        ? `mutation($documents: [UUID]) {
          deleteDocument(documents: $documents) {
            success
          }
        }`
        : deleteFolders.length > 0
        ? `mutation($folders: [UUID]) {
          deleteFolders(folders: $folders) {
            success
          }
        }`
        : ``;
    const variables =
      deleteDocuments.length > 0 && deleteFolders.length > 0
        ? {
            documents: deleteDocuments,
            folders: deleteFolders,
          }
        : deleteDocuments.length > 0
        ? {
            documents: deleteDocuments,
          }
        : deleteFolders.length > 0
        ? {
            folders: deleteFolders,
          }
        : {};

    apolloClient
      .mutate({
        mutation: gql`
          ${MUTATION}
        `,
        variables: variables,
      })
      .then((result) => {
        const updatedDeleteList = [...this.state.delete, ...selectedItems];
        const updateDocumentItems = this.state.documentItems.filter(
          (document) =>
            !updatedDeleteList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        const folderLists = this.props.archivedItems.filter(
          (document) =>
            !updatedDeleteList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        this.props.setFolderList(folderLists, updatedDeleteList);
        this.setState({
          delete: updatedDeleteList,
          documentItems: updateDocumentItems,
          totalDocuments: updateDocumentItems.length,
          selectAll: false,
        });

        const detail = "Success";
        const title = "All items have been successfully deleted";
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  deleteHandler = (archiveId, id, itemTitle, isFolder, item) => {
    const MUTATION = isFolder ? DELETE_FOLDER : DELETE_DOCUMENT;
    const variables = isFolder
      ? {
          folders: [archiveId],
        }
      : {
          documents: [archiveId],
        };
    apolloClient
      .mutate({
        mutation: gql`
          ${MUTATION}
        `,
        variables: variables,
      })
      .then((result) => {
        const deleteItems = this.state.documentItems.filter(
          (key) => key.id === id
        );
        const updatedDeleteList = [...this.state.delete, ...deleteItems];
        const updateDocumentItems = this.state.documentItems.filter(
          (document) =>
            !updatedDeleteList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        const folderLists = this.props.archivedItems.filter(
          (document) =>
            !updatedDeleteList.filter(
              (updatedDocument) => updatedDocument.id === document.id
            ).length
        );
        this.props.setFolderList(folderLists, deleteItems);
        this.setState({
          delete: updatedDeleteList,
          documentItems: updateDocumentItems,
          totalDocuments: updateDocumentItems.length,
        });

        const detail = "Success";
        const title = `${itemTitle} deleted successfully!`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  sortColumnHandler = ({ column, status } = this.state.sortingValue) => {
    if (this.sortableColumns.includes(column)) {
      this.setState(
        {
          sortingValue: { column, status },
        },
        () => this.getFilteredData()
      );
    }
  };

  onColumnSelectedHandler = (newHeading) => {
    this.setState({ heading: ["files", ...newHeading] });
  };

  setDateFilter = (startDate, endDate) => {
    this.setState(
      {
        startDate,
        endDate,
      },
      () => this.getFilteredData()
    );
  };

  getCategories = () => {
    let categories;
    if (this.props.isSubFolderArchive) {
      const foldersTitle = this.state.subFolderItems.map(
        (subFolderItem) => subFolderItem.parentTitle
      );
      categories = {
        Folder: [...foldersTitle],
      };
    } else if (this.props.isDocumentArchive) {
      const documentTypes = [];
      this.state.docItems.map((docItem) => {
        const title = docItem.documentType.title;
        !documentTypes.includes(title) && documentTypes.push(title);
        return true;
      });
      categories = {
        "Document Type": [...documentTypes],
      };
    }
    return categories;
  };

  handleFieldFilter = (filterdocumentItems, fieldLabel, fieldDataObject) => {
    let filteredDocument = filterdocumentItems;
    if (fieldDataObject["inputType"] === "Date") {
      if (fieldDataObject["filter"] === "Before") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) <
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "After") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) >
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "On") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(item[fieldLabel]).setHours(0, 0, 0, 0) ===
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "Between") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            new Date(fieldDataObject["fieldValue1"]).setHours(0, 0, 0, 0) <=
              new Date(item[fieldLabel]).setHours(0, 0, 0, 0) &&
            new Date(fieldDataObject["fieldValue2"]).setHours(0, 0, 0, 0) >=
              new Date(item[fieldLabel]).setHours(0, 0, 0, 0)
        );
      } else if (fieldDataObject["filter"] === "Is blank") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === "-"
        );
      }
    } else if (fieldDataObject["inputType"] === "Number") {
      if (fieldDataObject["filter"] === "Is equal") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === fieldDataObject["fieldValue1"]
        );
      } else if (fieldDataObject["filter"] === "Does not equal") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] !== fieldDataObject["fieldValue1"]
        );
      } else if (fieldDataObject["filter"] === "Is blank") {
        filteredDocument = filteredDocument.filter(
          (item) => item[fieldLabel] === ""
        );
      } else if (fieldDataObject["filter"] === "Is less than") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            parseInt(item[fieldLabel]) <
            parseInt(fieldDataObject["fieldValue1"])
        );
      } else if (fieldDataObject["filter"] === "Is greater than") {
        filteredDocument = filteredDocument.filter(
          (item) =>
            parseInt(item[fieldLabel]) >
            parseInt(fieldDataObject["fieldValue1"])
        );
      }
    } else if (
      fieldDataObject["inputType"] === "TextField" ||
      fieldDataObject["inputType"] === "TextArea"
    ) {
      filteredDocument = filteredDocument.filter(
        (item) =>
          item[fieldLabel] &&
          item[fieldLabel].search(fieldDataObject["value"]) >= 0
      );
    }
    return filteredDocument;
  };

  filterApplyHandler = (data) => {
    this.setState(
      {
        filterData: data,
      },
      () => this.getFilteredData()
    );
  };

  setSearchFilter = (value) => {
    this.setState(
      {
        searchValue: value,
      },
      () => this.getFilteredData()
    );
  };

  getFilteredData = () => {
    const { sortingValue, filterData, startDate, endDate } = this.state;
    const { status, column } = sortingValue;

    let documentItems = this.props.isSubFolderArchive
      ? [...this.state.subFolderItems]
      : this.props.isDocumentArchive
      ? [...this.state.docItems]
      : [...this.props.archivedItems];

    if (startDate && endDate) {
      let startDate1 = new Date(`${startDate._d}`);
      let endDate1 = new Date(`${endDate._d}`);

      documentItems = documentItems.filter((newDocumentItem) => {
        let archivedTillTs = new Date(newDocumentItem.archivedTill);

        //start Date-->
        let Difference_In_Time1 = archivedTillTs - startDate1;
        let Difference_In_Days1 = Math.round(Difference_In_Time1 / (1000 * 3600 * 24) + 1);

        // end Date-->
        let Difference_In_Time2 = endDate1 - archivedTillTs;
        let Difference_In_Days2 = Math.round(Difference_In_Time2 / (1000 * 3600 * 24) + 1);

        return Difference_In_Days1 >= 1 && Difference_In_Days2 > 1;
      });
    }

    if (this.props.isSubFolderArchive) {
      const folderArr = filterData.Folder || [];
      if (folderArr.length > 0) {
        const updatedSubFolders = [...this.state.subFolderItems];
        documentItems = updatedSubFolders.filter((updatedSubFolder) =>
          folderArr.includes(updatedSubFolder.parentTitle)
        );
      }
    } else if (this.props.isDocumentArchive) {
      let fieldFilter = filterData;

      Object.entries(fieldFilter).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          documentItems = this.handleFieldFilter(documentItems, key, value);
        } else {
          let filterDocuments = documentItems.filter((item) => value.find((title) => title === item[key]));

          if (filterDocuments.length === 0) {
            filterDocuments = documentItems.filter((item) =>
              value.find((title) => item[key] && item[key].includes(title))
            );
          }

          documentItems = filterDocuments;
        }
      });
    }

    // Column sort filter
    documentItems = documentItems.sort((a, b) => {
      if (status === ColumnSortingState.DESC) {
        [a, b] = [b, a];
      }

      if (column === "Archived On") {
        const dateA = a.archivedOn;
        const dateB = b.archivedOn;

        return new Date(dateA) - new Date(dateB);
      } else if (column === "Archived Till") {
        const dateA = a.archivedTill;
        const dateB = b.archivedTill;

        return new Date(dateA) - new Date(dateB);
      } else {
        console.log("a=>", a.title, a.document, a.folder);
        const titleA = a.title
          ? a.title
          : a.document
          ? a.document.title
          : a.folder.title
          ? a.folder.title
          : a.folder.parentFolder.title;

        const titleB = b.title
          ? b.title
          : b.document
          ? b.document.title
          : b.folder.title
          ? b.folder.title
          : b.folder.parentFolder.title;

        return titleA.toLowerCase() > titleB.toLowerCase() ? 1 : titleA < titleB.toLowerCase() ? -1 : 0;
      }
    });

    this.setState({
      documentItems: documentItems,
      totalDocuments: documentItems.length,
    });
  };


  // Document open section
  documentOnClickHandler = (docId, viewOnly = true) => {
    const doc = this.state.documentItems.find((item) => item.id === docId);
    this.setState({
      showDocumentDetailModal: true,
      documentDetailModalInfo: {
        title: doc.title,
        fileUrl: doc.fileUrl,
        documentObj: doc,
        viewOnly: viewOnly,
      },
    });
  };

  render() {
    return (
      <div className="col-md ml-8">
          {this.props.isDocumentArchive ? (
            <CustomizeColumnModal
              showModal={this.state.showCustomizeColumnModal}
              handleApply={this.onColumnSelectedHandler}
              handleCancel={() => {
                this.setState({
                  showCustomizeColumnModal: false,
                });
              }}
              availableColumns={this.state.availableColumns}
              selectedColumns={this.state.heading}
              isDocumentArchive={true}
              columnsDisplayMapping={this.columnsDisplayMapping}
              columns={this.state.columns}
              setColumns={(columns) => {
                this.setState({
                  columns
                })
              }}
              reloadColumns={this.state.reloadColumns}
              stopReloadColumns={() => {
                this.setState({
                  reloadColumns: false,
                });
              }}
            />
          ) : null }
        <>
          <div className="row archived-bread">
            <ArchiveBreadcrumbs
              {...this.props}
              documentItems={this.state.documentItems}
            />
            <DocumentView
              archiveView={true}
              showModal={this.state.showDocumentDetailModal}
              handleClose={(shouldReLoadData = false) => {
                this.setState({ showDocumentDetailModal: false, shouldShowDocumentModal: false });
                if (shouldReLoadData) {
                  this.setState({
                    reloadColumns: true,
                  })
                  // this.props.loadData();
                }
              }}
              setArchiveModalVisibility={() => {}}
              userRoleId={this.props.userRoleId}
              currentUserInfo={this.props.currentUserInfo}
              documentHandleShare={(data) => {
                this.props.setShareFolder(data.documentObj);
              }}
              showShareModal={false}
              showArchiveModal={false}
              fileUrl={this.state.documentDetailModalInfo.fileUrl}
              handleEdit={() => {}}
              {...this.state.documentDetailModalInfo}
                // {...this.props}
            />
            {this.state.totalDocuments > 0 || this.state.filterLength ? (
              <FolderRoute
                isArchivedView={this.state.isArchivedView}
                displayListView={this.state.displayListView}
                restoreAllHandler={this.restoreAllHandler}
                deleteAllHandler={this.deleteAllHandler}
                totalChecked={this.totalChecked}
                totalDocuments={this.state.totalDocuments}
                availableColumns={this.state.availableColumns}
                selectedColumns={this.state.heading}
                columnsDisplayMapping={this.columnsDisplayMapping}
                onColumnSelectedHandler={this.onColumnSelectedHandler}
                selectedColumn={this.state.selectedColumn}
                setDateFilter={this.setDateFilter}
                isSubFolderArchive={this.props.isSubFolderArchive}
                isDocumentArchive={this.props.isDocumentArchive}
                categories={this.getCategories()}
                filterApplyHandler={this.filterApplyHandler}
                documents={this.state.docItems}
                {...this.props}
              />
            ) : null}
          </div>
          {this.props.isLoading ? (
            <div className="loader-icon">
              <Spinner animation="border" role="status" />
            </div>
          ) : this.state.totalDocuments > 0 ? (
            <div className="row pt-6">
              <div className="col-md">
                {this.state.filterLength ? (
                  <div className="is-size-h4" style={{ textAlign: "center" }}>
                    Archives not found
                  </div>
                ) : (
                  <div className="table-responsive archived-list">
                    <table className="table table-hover">
                      <thead>
                        <tr className="folderlist-header table-borderless">
                          {this.state.heading.map((headKey) => (
                            <ListViewHeader
                              key={headKey}
                              columnName={
                                this.columnsDisplayMapping[headKey]
                                  ? this.columnsDisplayMapping[headKey]
                                  : headKey
                              }
                              count={this.state.totalDocuments}
                              checked={this.state.selectAll}
                              selectAllHandler={this.selectAllHandler}
                              isCheckbox={this.state.isColumns.isCheckbox}
                              sortingValue={this.state.sortingValue}
                              sortColumnHandler={this.sortColumnHandler}
                            />
                          ))}
                          {/* Column customization action button */}
                          {this.props.isDocumentArchive ? (
                            <th scope="col">
                              <img
                                className="column-icon"
                                src={ColumnsIcon}
                                alt="Customize Columns"
                                width="24"
                                height="24"
                                onClick={() =>  this.setState({
                                  showCustomizeColumnModal: true,
                                })}
                              />
                            </th>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.documentItems.map((rKey) => {
                          return (
                            <DynamicListViewRows
                              item={rKey}
                              role={rKey.role}
                              getIntials={getIntials(rKey.archivedBy)}
                              headings={this.state.heading}
                              checkHandler={this.checkHandler}
                              checked={this.state.checked[rKey.id]}
                              isColumns={this.state.isColumns}
                              size={this.state.tableSizeLarge}
                              isFolder={rKey.isFolder}
                              restoreHandler={this.restoreHandler}
                              deleteHandler={this.deleteHandler}
                              isArchivedView={this.state.isArchivedView}
                              onClick={this.documentOnClickHandler}
                              {...this.props}
                            />
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          ) : !this.state.isLoading ? (
            this.state.filterLength ? (
              <div className="is-size-h4 mt-4" style={{ textAlign: "center" }}>
                Archives not found
              </div>
            ) : (
              <div className="is-size-h2 bold no-archived">
                <EmptyStates
                  imgSrc={emptyArchiveImage}
                  emptyStateTitle="Looks like you haven’t archived anything yet !"
                  emptyStateButtons={[]}
                  {...this.props}
                />
              </div>
            )
          ) : (
            <div className="loader-icon">
              <Spinner animation="border" role="status" />
            </div>
          )}
        </>
      </div>
    );
  }
}

export default ArchivedListView;
